"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fields = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fields = exports.fields = ['password', 'repeatPassword', 'termsandconds'];
var validate = function validate(values, props) {
  var errors = {};
  if (!values.password) {
    errors.password = 'Password is required';
  } else if (values.password !== values.repeatPassword) {
    errors.repeatPassword = 'The passwords must match';
  }
  if (!values.termsandconds) {
    errors.termsandconds = 'The privacy policy and terms of use must be accepted to continue';
  }
  return errors;
};
var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);
  function Form() {
    _classCallCheck(this, Form);
    return _callSuper(this, Form, arguments);
  }
  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$fields = _this$props.fields,
        password = _this$props$fields.password,
        repeatPassword = _this$props$fields.repeatPassword,
        termsandconds = _this$props$fields.termsandconds,
        handleSubmit = _this$props.handleSubmit,
        submitting = _this$props.submitting,
        username = _this$props.username,
        fullName = _this$props.fullName;
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit
      }, /*#__PURE__*/_react["default"].createElement("h3", null, "Welcome, ", fullName || username, "!"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "panel panel-default"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "panel-heading"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          fontSize: '20px'
        }
      }, "Create a password for your account with username", ' ', /*#__PURE__*/_react["default"].createElement("strong", null, username))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "panel-body"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          maxWidth: '350px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: password,
        label: "Create Password",
        type: "password"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          maxWidth: '350px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: repeatPassword,
        label: "Confirm Password",
        type: "password"
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "panel panel-default"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "panel-heading"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          fontSize: '20px',
          fontWeight: 'bold'
        }
      }, "3C Privacy Policy and Terms of Use")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "panel-body"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].terms
      }, /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.3cisd.com/privacy-policy?page_id=3110",
        target: "blank"
      }, "Privacy Policy")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "http://www.3cisd.com/terms-of-use",
        target: "blank"
      }, "Terms of Use"))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "panel-footer"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: termsandconds
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox"
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(termsandconds))), "I accept the privacy policy and terms of use."))))), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-primary",
        title: "Activate",
        isLoading: submitting,
        onClick: handleSubmit
      }));
    }
  }]);
  return Form;
}(_react["default"].Component);
_defineProperty(Form, "propTypes", {
  fields: _propTypes["default"].object.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  submitting: _propTypes["default"].bool.isRequired,
  username: _propTypes["default"].string,
  fullName: _propTypes["default"].string
});
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  fields: fields,
  initialValues: {
    password: '',
    repeatPassword: '',
    termsandconds: false
  },
  validate: validate
})(Form);